module.exports = __webpack_public_path__ + "img/bg.36d2a865.png";